<template>
  <div class="page flex-col">
    <!-- <div class="block_15 flex-col">
      <div class="group_17 flex-row">
        <img
          class="label_5"
          referrerpolicy="no-referrer"
          src="@/assets/icon/icon_scan.png"
        />
        <div class="image-wrapper_5 flex-col">
          <img
            class="label_6"
            referrerpolicy="no-referrer"
            src="@/assets/icon/icon_search.png"
          />
        </div>
        <img
          class="label_7"
          @click="kefu_to"
          referrerpolicy="no-referrer"
          src="@/assets/icon/icon_kf2.png"
        />
        <img
          class="label_8"
          referrerpolicy="no-referrer"
          src="@/assets/icon/icon_message.png"
        />
      </div>
    </div> -->
    <div class="block_1 flex-col">
      <img class="title" src="@/assets/images/icon_wuxingbi_title.png" />
      <img class="money" src="@/assets/images/icon_wuxingbi_money.png" />
      <img class="module" src="@/assets/images/icon_wuxingbi_module1.png" />
      <div class="module2">
        <div class="invite-item" v-for="(item,index) in inviteList" :key="index">
            <div class="invite-left">
                <div class="invite-label">邀请 <br><span>{{item.num}}人</span></div>
                <div class="invite-desc">赠送五行币{{item.wxb}}枚<br>{{item.money}}元</div>
            </div>
            <button class="invite-btn" @click="invite_reward_claimed(item.reward_id)">立即领取</button>
        </div>
        <!-- <img src="@/assets/images/icon_wuxingbi_module2_fuli1.png" />
        <img src="@/assets/images/icon_wuxingbi_module2_fuli2.png" />
        <img src="@/assets/images/icon_wuxingbi_module2_fuli3.png" />
        <img src="@/assets/images/icon_wuxingbi_module2_fuli4.png" />
        <img src="@/assets/images/icon_wuxingbi_module2_fuli5.png" />
        <img src="@/assets/images/icon_wuxingbi_module2_fuli6.png" />
        <img src="@/assets/images/icon_wuxingbi_module2_fuli7.png" /> -->
      </div>
      <img class="module" src="@/assets/images/icon_wuxingbi_module3.png" />
      <div class="module4">
        <div class="code">{{data.invitation_code}}</div>
        <img loading="lazy" class="qrcode" :src="data.share_image_url" alt="">
        <div class="tip">扫码邀请好友</div>
        <div class="btn" @click="copyLink">复制链接 点击邀请</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import { WOW } from "wowjs";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";
import "swiper/dist/css/swiper.css";
import Fetch from "../../utils/fetch";
import Api from "../../interface/index";

import {
  Swipe,
  SwipeItem,
  Icon,
  Progress,
  Dialog,
  Field,
  Circle,
  Switch,
  Empty,
  Toast
} from "vant";
import Clipboard from "v-clipboard";

Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(Circle).use(Switch).use(Empty).use(Clipboard).use(Toast);

export default {
  name: "wuxingbi",
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem,
    swiper,
    videoPlayer,
    swiperSlide,
  },
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      data: {},
      inviteList: [
          {    reward_id: "invite_1", num: 3,   wxb: 3,   money: 60000 },
          {   reward_id: "invite_2", num: 10,  wxb: 10,  money: 200000 },
          {   reward_id: "invite_3", num: 30,  wxb: 30,  money: 600000 },
          {   reward_id: "invite_4", num: 50,  wxb: 50,  money: 1000000 },
          {  reward_id: "invite_5", num: 100, wxb: 100, money: 2000000 },
          {  reward_id: "invite_6", num: 150, wxb: 150, money: 4000000 },
          {  reward_id: "invite_7", num: 300, wxb: 300, money: 10000000 }
      ]

    };
  },
  created() {
    this.$parent.footer("wuxingbi");
  },
  mounted() {
    // 看个人信息
    this.starts();
  },
  methods: {
    invite_reward_claimed(reward_id){
      Fetch("/user/invite_reward_claimed",{
        reward_id
      }).then((r) => {
        Toast.success('领取成功');;
      });
    },
    copyLink() {
          navigator.clipboard.writeText(this.data.share_link).then(() => {
              Toast.success('复制成功');;
          });
      },
    starts() {
      Fetch("/user/myTeam").then((r) => {
        this.data = r.data;
      });
    },
    kefu_to() {
      // if (this.show_kefu) {
      // 	this.$router.push('/kefu');
      // }
      // this.show_kefu = !this.show_kefu;
      Fetch("/user/system_info").then((r) => {
        window.location.href = r.data.service;
        // window.open(r.data.service, '_blank');
      });
    },
  },
};
</script>
<style src="@/assets/styles/common.css" />
<style lang="less" scoped>
.page {
  position: relative;
  width: 10rem;
  overflow: hidden;
  .block_15 {
    background-color: rgba(255, 255, 255, 1);
    height: 1.7rem;
    border: 1px solid rgba(226, 226, 226, 1);
    width: 10rem;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1;
    .group_17 {
      width: 9.054rem;
      height: 0.96rem;
      margin: 0.4rem 0 0.32rem 0.48rem;
      .label_5 {
        width: 0.52rem;
        height: 0.467rem;
        margin-top: 0.24rem;
      }
      .image-wrapper_5 {
        background-color: rgba(247, 247, 247, 1);
        border-radius: 10px;
        height: 0.96rem;
        margin-left: 0.387rem;
        width: 6.214rem;
        .label_6 {
          
        }
      }
      .label_7 {
        width: 0.494rem;
        height: 0.494rem;
        margin: 0.227rem 0 0 0.4rem;
      }
      .label_8 {
        width: 0.52rem;
        height: 0.494rem;
        margin: 0.227rem 0 0 0.52rem;
      }
    }
  }
  .block_1 {
    position: relative;
    width: 10rem;
    background: url(~@/assets/wuxingbi_bg.png) 100% no-repeat;
    background-size: 10rem 100%;
    // padding-top: 1.7rem;
    padding-bottom: 60px;
    background-position: top center;
    .title{
      margin: 2rem .3rem .66rem .3rem;
      width: 9.4rem;
      height: 3.2rem;
    }
    .money{
      margin: 0 0 .66rem 0;
      width: 10rem;
    }
    .module{
      width: 9rem;
      margin: 0 .5rem;
    }
    .module2{
      background: url(~@/assets/images/icon_wuxingbi_module2.png) 100% no-repeat;
      background-size: 9rem 100%;
      padding-top: 1.6rem;
      margin: 0.5rem .5rem .2rem .5rem;
      padding: 1.5rem .5rem 0.2rem .5rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      img{
        width: 100%;
        margin-bottom: .24rem;
      }
    }
    .module4{
      background: url(~@/assets/images/icon_wuxingbi_module4.png) 100% no-repeat;
      background-size: 100% 100%;
      width: 9rem;
      height: 9rem;
      padding-top: 2.2rem;
      margin: 0.3rem .5rem .5rem .5rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 0.27rem;
      .code{
        font-family: SourceHanSansCN;
        font-weight: bold;
        font-size: 1.07rem;
        color: #FE120C;
        line-height: 1.77rem;
        letter-spacing: .2rem;
        padding-left: .2rem;
        margin-top: -.1rem;
      }
      .qrcode{
        width: 2.8rem;
        margin-top: -.2rem;
      }
      .tip{
        font-family: SourceHanSansCN;
        font-weight: 400;
        font-size: 0.48rem;
        color: #333333;
        margin: .15rem 0 .35rem;
      }
      .btn{
        width: 5.28rem;
        height: 1.07rem;
        /* 关键的亮面渐变 */
        background: linear-gradient(#FEE05C, #FE0106);

        /* 上亮下暗的内阴影 */
        box-shadow:
        inset 0 4px 8px rgba(255, 255, 255, 0.6),
        0 4px 12px rgba(255, 0, 0, 0.35);
        border-radius: 0.53rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: SourceHanSansCN;
        font-weight: 400;
        font-size: 0.4rem;
        color: #FFFFFF;
      }
    }
  }
}
/* 卡片区域 */
.invite-item {
    width: 100%;
    background: #FFF4F4;
    border-radius: 18px;
    padding: .2rem .3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .3rem;
}

/* 左侧文字 */
.invite-left {
    line-height: 1.5;
    display: flex;
    align-items: center;
}

.invite-label {
    font-size: 16px;
    color: #FE0106;
    font-weight: 600;
    margin-right: .3rem;
}

.invite-label span {
    font-size: 20px;
    font-weight: 700;
    margin-left: 4px;
}

.invite-desc {
    font-size: 16px;
    color: #8C4E4E;
    margin-top: 4px;
}

/* 右侧按钮 */
.invite-btn {
    width: 1.8rem;
    height: .8rem;
    border-radius: 10px;
    border: none;
    background: linear-gradient(45deg,#FEE05C, #FE0106);
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(254, 1, 6, 0.2);
}
</style>
